/**
 * Detects Arcade URLs and extracts the embed URL.
 *
 * Supported formats:
 *  - https://app.arcade.software/share/{flowId}
 *  - https://demo.arcade.software/{flowId}
 */

const ARCADE_PATTERNS = [
  // Share links: https://app.arcade.software/share/{flowId}
  /^https?:\/\/app\.arcade\.software\/share\/([a-zA-Z0-9_-]+)/,
  // Embed/demo links: https://demo.arcade.software/{flowId}
  /^https?:\/\/demo\.arcade\.software\/([a-zA-Z0-9_-]+)/,
] as const

export function parseArcadeUrl(
  url: string,
): { flowId: string; embedUrl: string } | null {
  for (const pattern of ARCADE_PATTERNS) {
    const match = url.match(pattern)
    if (match?.[1]) {
      const flowId = match[1]
      return {
        flowId,
        embedUrl: `https://demo.arcade.software/${flowId}?embed`,
      }
    }
  }
  return null
}

export function isArcadeUrl(url: string): boolean {
  return parseArcadeUrl(url) !== null
}
